import {queryBearerToken} from "./UserAuthentication";
import * as ActionTypes from "../constants/ActionTypes";
import {queryArticleOptionData} from "./ArticleData";
import {addDomainToCart, addItemToCart, queryNewCart} from "./Cart";
import {queryTopLevelDomains} from "./Domain";
import {agencyServerCMSArticles, agencyServerProjectArticles, lsConfigurator} from "../config/Config";
import {_initialSoftware, _useConfiguration} from "../selectors/GetParam";
import {toggleSelectionTriggered} from "./Util";
import {initialize as initializeForms} from "redux-form";
import {queryPromotionCodeStatusAndData} from "./PromotionCode";
import {putFormData} from "./FormData";
import {appInitialized} from "./AppInit";
import {getSoftwareLoaders} from "./AppInit.SoftwareLoaders";
import {selectCartProperty} from "./Properties";
import {queryAddInitialProject} from "./ProjectSelection";
import {isAgencyServer, isNextcloudArticle, isNonUsualArticleType} from "../selectors/ArticleNumbers";
import {ARTICLE_TYPE_CMS, DOMAIN_TYPE_CUSTOM, INVOICE_TYPE_EMAIL, PAYMENT_TYPE_SEPA, PROJECT_STATE_LIVE} from "../constants/General";
import {activateBaseArticle} from "./BaseArticle";
import {getBaseArticle} from "../selectors/SimpleSelectors";
import {getStepOrder} from "../selectors/UserInterface";

export const initializeApp = (baseArticleId, initParams) => (dispatch, getState) => {

    const {initialArticles, initialPromotionCode, initialDomains} = initParams


    Promise.all([
        dispatch(queryBearerToken())
    ]).then((args) => {
        if (args[0].type !== ActionTypes.BEARER_TOKEN_FAILURE) {

            const initialCalls = [
                activateBaseArticle(baseArticleId),
                queryNewCart(),
                queryTopLevelDomains()
            ]

            Promise.all(initialCalls.map(func => dispatch(func))).then((args) => {
                if (args[0] === true && args[1].type === ActionTypes.CART_CREATE_SUCCESS && args[2].type === ActionTypes.TOPLEVELDOMAINS_SUCCESS) {
                    Promise.all([
                        dispatch(addItemToCart(baseArticleId)),
                        ...getSoftwareLoaders(getState().articleData.baseArticle.type).map(func => dispatch(func)),
                        // iterate through articleOptions and load data if price not available
                        dispatch(queryArticleOptionData(
                            [
                                ...initialArticles.filter(key => {
                                    return (getState().articleData.articleOptions[key] && getState().articleData.articleOptions[key].price) ? null : key
                                }),
                                ...isAgencyServer(baseArticleId) ? agencyServerProjectArticles : [],
                                ...(Object.keys(getState().articleData.articleOptions).filter(key => {
                                    return (key.includes("default") || getState().articleData.articleOptions[key].price) ? null : key
                                }))
                            ]
                        )),
                    ]).then((args) => {
                        const postInitCalls = []
                        const baseArticle = getBaseArticle(getState());

                        // set initial form data if affiliateId is available

                        // add initial articles
                        if (initialArticles && initialArticles.length > 0) {
                            initialArticles.forEach(articleNumber => {
                                postInitCalls.push(addItemToCart(articleNumber))
                            })
                        }

                        // add initial domains
                        if (initialDomains && initialDomains.length > 0) {
                            initialDomains.forEach(domainName => {
                                postInitCalls.push(addDomainToCart(domainName))
                            })
                        }

                        // pre-select phone verification
                        postInitCalls.push(toggleSelectionTriggered('phoneVerificationType', 'phone'))
                        postInitCalls.push(toggleSelectionTriggered('billingType', PAYMENT_TYPE_SEPA))
                        postInitCalls.push(toggleSelectionTriggered('invoiceType', INVOICE_TYPE_EMAIL))

                        postInitCalls.push(toggleSelectionTriggered('domainType', DOMAIN_TYPE_CUSTOM))

                        if (isAgencyServer(baseArticleId)) {

                            const configuratorState = localStorage.getItem(lsConfigurator + "_shared")

                            if (configuratorState && _useConfiguration) {
                                const configuratorData = JSON.parse(configuratorState)
                                /*dispatch(toggleSelectionTriggered('projectConfiguration', PROJECT_TYPE_CREATE))*/

                                if (
                                    configuratorData && configuratorData.form &&
                                    configuratorData.form.projectSelection &&
                                    configuratorData.form.projectSelection.values) {
                                    if (configuratorData.form.projectSelection.values.backup) {
                                        configuratorData.form.projectSelection.values.backup = parseInt(configuratorData.form.projectSelection.values.backup);
                                    } else {
                                        configuratorData.form.projectSelection.values.backup = 7;
                                    }
                                    dispatch(initializeForms('projectSelection',
                                        configuratorData.form.projectSelection.values
                                    ))
                                    localStorage.removeItem(lsConfigurator + "_shared");

                                    postInitCalls.push(queryAddInitialProject())
                                }
                            } else {
                                dispatch(initializeForms('projectSelection',
                                    {
                                        type: ARTICLE_TYPE_CMS,
                                        state: PROJECT_STATE_LIVE,
                                        article: "" + agencyServerCMSArticles[1],
                                        storage: "",
                                        backup: 7,
                                    }
                                ))
                                postInitCalls.push(queryAddInitialProject())
                            }
                        } else {

                            const configuratorState = localStorage.getItem(lsConfigurator + "_" + _useConfiguration);

                            if (configuratorState && _useConfiguration) {

                                const configuratorData = JSON.parse(configuratorState)

                                if (
                                    configuratorData && configuratorData.form &&
                                    configuratorData.form.projectSelection &&
                                    configuratorData.form.projectSelection.values) {
                                    if (configuratorData.form.projectSelection.values.backup) {
                                        dispatch(selectCartProperty("backupRange", configuratorData.form.projectSelection.values.backup));
                                        configuratorData.form.projectSelection.values.backup = parseInt(configuratorData.form.projectSelection.values.backup);
                                    }
                                    dispatch(initializeForms('projectSelection',
                                        configuratorData.form.projectSelection.values
                                    ))
                                    localStorage.removeItem(lsConfigurator + "_" + _useConfiguration);
                                    /*dispatch(queryProjectSelection(
                                        configuratorData.form.projectSelection.values
                                    ));*/
                                }
                            } else {
                                dispatch(initializeForms('projectSelection',
                                    {
                                        article: baseArticleId,
                                        storage: "",
                                        state: PROJECT_STATE_LIVE,
                                        backup: 7,
                                        type: ARTICLE_TYPE_CMS
                                    }
                                ))
                            }

                            if (baseArticle && !isNonUsualArticleType(baseArticle.type)) {
                                // initial backup for new carts
                                if (!_useConfiguration) {
                                    dispatch(selectCartProperty("backupRange", 7));
                                }
                            }
                            if (isNextcloudArticle(baseArticleId)) {

                                dispatch(selectCartProperty("software", "nextcloud"));

                            } else if (!isNonUsualArticleType(baseArticle.type)) {

                                dispatch(selectCartProperty("software", _initialSoftware ? _initialSoftware : ""));

                            }
                        }

                        postInitCalls.push(selectCartProperty('billingPeriod', 4));

                        Promise.all(postInitCalls.map(func => dispatch(func))).then(args => {
                            if (_useConfiguration) {
                                let dataLayerObject = {
                                    event: 'entryPoint',
                                    entryPointSource: 'configurator',
                                    configuratorMode: _useConfiguration
                                }
                                if (window.dataLayer) {
                                    window.dataLayer.push(dataLayerObject);
                                }
                            }

                            const initialStep = getStepOrder(getState())[0];

                            // set initial promotion code
                            if (initialPromotionCode) {
                                dispatch(initializeForms('promotionCodeForm',
                                    {
                                        promotionCode: initialPromotionCode
                                    }
                                ))

                                dispatch(queryPromotionCodeStatusAndData()).then(args => {
                                    dispatch(appInitialized({...initParams, initialStep: initialStep}))
                                    dispatch(putFormData())
                                })
                            } else {
                                dispatch(appInitialized({...initParams, initialStep: initialStep}))
                                dispatch(putFormData())
                            }
                        })
                    })
                }
            })
        }
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.Regular.js
 **/